// Mock data for demo.minitask.no
// All data is fictional and used for demonstration purposes only

// ============ MOCK USERS ============
export const DEMO_USER = {
  id: 1,
  name: 'Demo Bruker',
  email: 'demo@minitask.no',
  phone: '12345678',
  profile_image: null,
  location_fylke: 'oslo',
  location_city: 'oslo',
  user_type: 'worker',
  is_verified: true,
  is_business: false,
  birth_year: 2009, // 17 år
  created_at: '2025-09-01T10:00:00Z',
  bio: 'Jeg er en 17-åring som liker å jobbe og tjene egne penger. Hardtarbeidende og pålitelig!'
};

export const MOCK_USERS = [
  DEMO_USER,
  {
    id: 2,
    name: 'Hagesenter AS',
    email: 'post@hagesenter.no',
    phone: '22334455',
    profile_image: null,
    location_fylke: 'oslo',
    location_city: 'oslo',
    user_type: 'poster',
    is_verified: true,
    is_business: true,
    business_name: 'Hagesenter AS',
    org_number: '123456789',
    created_at: '2025-06-15T08:00:00Z',
    bio: 'Vi er et lokalt hagesenter som av og til trenger ekstra hjelp.'
  },
  {
    id: 3,
    name: 'Kari Nordmann',
    email: 'kari@example.no',
    phone: '99887766',
    profile_image: null,
    location_fylke: 'oslo',
    location_city: 'oslo',
    user_type: 'poster',
    is_verified: true,
    is_business: false,
    birth_year: 1960, // 65 år
    created_at: '2025-08-20T14:00:00Z',
    bio: 'Pensjonist som trenger litt hjelp med diverse oppgaver hjemme.'
  },
  {
    id: 4,
    name: 'Erik Hansen',
    email: 'erik@example.no',
    phone: '45678901',
    profile_image: null,
    location_fylke: 'viken',
    location_city: 'drammen',
    user_type: 'worker',
    is_verified: true,
    is_business: false,
    birth_year: 2010, // 16 år
    created_at: '2025-10-01T12:00:00Z',
    bio: 'Ung og energisk! Elsker å hjelpe til og lære nye ting.'
  },
  {
    id: 5,
    name: 'Flyttebyrå Oslo',
    email: 'kontakt@flyttebyra.no',
    phone: '21212121',
    profile_image: null,
    location_fylke: 'oslo',
    location_city: 'oslo',
    user_type: 'poster',
    is_verified: true,
    is_business: true,
    business_name: 'Flyttebyrå Oslo AS',
    org_number: '987654321',
    created_at: '2025-05-01T09:00:00Z',
    bio: 'Vi trenger ofte ekstra bærehjelp på travle dager!'
  },
  {
    id: 6,
    name: 'Lise Johansen',
    email: 'lise@example.no',
    phone: '91827364',
    profile_image: null,
    location_fylke: 'rogaland',
    location_city: 'stavanger',
    user_type: 'poster',
    is_verified: true,
    is_business: false,
    birth_year: 1985,
    created_at: '2025-07-10T16:00:00Z',
    bio: 'Trebarnsmor som av og til trenger litt ekstra hjelp.'
  }
];

// ============ MOCK JOBS (OPPDRAG) ============
export const MOCK_JOBS = [
  {
    id: 1,
    title: 'Trenger hjelp med plenklipping',
    description: 'Jeg har en stor hage på ca. 500 kvm som trenger klipping. Gressklipperen er på plass, du trenger bare å gjøre jobben. Estimert tid: 2-3 timer. Perfekt for noen som liker å være ute!',
    category: 'hagearbeid',
    location_fylke: 'oslo',
    location_city: 'oslo',
    price: 500,
    job_type: 'oppdrag',
    pricing_type: 'fixed',
    hourly_rate: null,
    status: 'active',
    created_at: '2026-01-10T09:00:00Z',
    images: [],
    poster: {
      id: 3,
      name: 'Kari Nordmann',
      profile_image: null,
      is_verified: true
    }
  },
  {
    id: 2,
    title: 'Bærehjelp ved flytting',
    description: 'Vi trenger ekstra hender til å bære møbler og esker fra 3. etasje ned til flyttebil. Jobben tar ca. 4 timer. Du må kunne løfte tungt og jobbe i team.',
    category: 'flyttehjelp',
    location_fylke: 'oslo',
    location_city: 'oslo',
    price: 200,
    job_type: 'oppdrag',
    pricing_type: 'hourly',
    hourly_rate: 200,
    status: 'active',
    created_at: '2026-01-09T14:00:00Z',
    images: [],
    poster: {
      id: 5,
      name: 'Flyttebyrå Oslo',
      profile_image: null,
      is_verified: true
    }
  },
  {
    id: 3,
    title: 'Vindusvask i leilighet',
    description: 'Trenger noen til å vaske vinduer i min leilighet. Det er 8 vinduer totalt, pluss balkongdør. Alt utstyr er på plass. Estimert tid: 1-2 timer.',
    category: 'rengjoring',
    location_fylke: 'oslo',
    location_city: 'oslo',
    price: 350,
    job_type: 'oppdrag',
    pricing_type: 'fixed',
    hourly_rate: null,
    status: 'active',
    created_at: '2026-01-08T11:00:00Z',
    images: [],
    poster: {
      id: 3,
      name: 'Kari Nordmann',
      profile_image: null,
      is_verified: true
    }
  },
  {
    id: 4,
    title: 'Male gjerde',
    description: 'Jeg har et hvitt stakittgjerde som trenger et nytt strøk maling. Gjerdet er ca. 20 meter langt. Maling og pensler er inkludert. Kan gjøres over 1-2 dager.',
    category: 'smajobber',
    location_fylke: 'viken',
    location_city: 'drammen',
    price: 1200,
    job_type: 'oppdrag',
    pricing_type: 'fixed',
    hourly_rate: null,
    status: 'active',
    created_at: '2026-01-07T16:00:00Z',
    images: [],
    poster: {
      id: 6,
      name: 'Lise Johansen',
      profile_image: null,
      is_verified: true
    }
  },
  {
    id: 5,
    title: 'Hundelufting i 2 uker',
    description: 'Jeg skal på ferie og trenger noen til å lufte hunden min (Golden Retriever, veldig snill) to ganger daglig i 2 uker. Morgen og kveld, ca. 30 min hver tur.',
    category: 'dyrepass',
    location_fylke: 'oslo',
    location_city: 'oslo',
    price: 2500,
    job_type: 'oppdrag',
    pricing_type: 'fixed',
    hourly_rate: null,
    status: 'active',
    created_at: '2026-01-06T10:00:00Z',
    images: [],
    poster: {
      id: 6,
      name: 'Lise Johansen',
      profile_image: null,
      is_verified: true
    }
  },
  {
    id: 6,
    title: 'Hente møbler fra IKEA',
    description: 'Trenger noen med stor bil/tilhenger til å hente en sofa og et bord fra IKEA Furuset. Må kunne bære møblene opp til 2. etasje.',
    category: 'transport',
    location_fylke: 'oslo',
    location_city: 'oslo',
    price: 600,
    job_type: 'oppdrag',
    pricing_type: 'fixed',
    hourly_rate: null,
    status: 'active',
    created_at: '2026-01-05T13:00:00Z',
    images: [],
    poster: {
      id: 3,
      name: 'Kari Nordmann',
      profile_image: null,
      is_verified: true
    }
  },
  {
    id: 7,
    title: 'Sette opp ny PC',
    description: 'Har kjøpt ny PC og trenger hjelp til å sette den opp, installere programmer og overføre filer fra den gamle. Skulle gjerne hatt hjelp med oppsett av skriver også.',
    category: 'it-hjelp',
    location_fylke: 'oslo',
    location_city: 'oslo',
    price: 400,
    job_type: 'oppdrag',
    pricing_type: 'fixed',
    hourly_rate: null,
    status: 'active',
    created_at: '2026-01-04T15:00:00Z',
    images: [],
    poster: {
      id: 3,
      name: 'Kari Nordmann',
      profile_image: null,
      is_verified: true
    }
  },
  {
    id: 8,
    title: 'Hjelp med rydding i kjeller',
    description: 'Trenger hjelp til å rydde og sortere ting i kjellerbod. Noe må kastes, noe skal til loppemarked. Ca. 3-4 timers jobb.',
    category: 'annet',
    location_fylke: 'oslo',
    location_city: 'oslo',
    price: 180,
    job_type: 'oppdrag',
    pricing_type: 'hourly',
    hourly_rate: 180,
    status: 'active',
    created_at: '2026-01-03T09:00:00Z',
    images: [],
    poster: {
      id: 3,
      name: 'Kari Nordmann',
      profile_image: null,
      is_verified: true
    }
  }
];

// ============ MOCK SERVICES (TJENESTER) ============
export const MOCK_SERVICES = [
  {
    id: 101,
    title: 'Profesjonell hundelufting',
    description: 'Jeg elsker hunder og tilbyr hundelufting i Oslo-området. Har erfaring med alle typer hunder og er pålitelig. Kan lufte både morgen, ettermiddag og kveld.',
    category: 'dyrepass',
    location_fylke: 'oslo',
    location_city: 'oslo',
    price: 150,
    job_type: 'tjeneste',
    pricing_type: 'hourly',
    hourly_rate: 150,
    status: 'active',
    created_at: '2026-01-08T12:00:00Z',
    images: [],
    poster: {
      id: 4,
      name: 'Erik Hansen',
      profile_image: null,
      is_verified: true
    }
  },
  {
    id: 102,
    title: 'PC-hjelp og teknisk support',
    description: 'Kan hjelpe med alt fra å sette opp nye PCer, installere programmer, fikse problemer, til opplæring i bruk. Jeg er flink med teknologi og forklarer ting på en enkel måte.',
    category: 'it-hjelp',
    location_fylke: 'oslo',
    location_city: 'oslo',
    price: 200,
    job_type: 'tjeneste',
    pricing_type: 'hourly',
    hourly_rate: 200,
    status: 'active',
    created_at: '2026-01-07T14:00:00Z',
    images: [],
    poster: {
      id: 1,
      name: 'Demo Bruker',
      profile_image: null,
      is_verified: true
    }
  },
  {
    id: 103,
    title: 'Hagearbeid og plenklipping',
    description: 'Tilbyr hagearbeid som plenklipping, luking, planting og generelt vedlikehold. Har egen gressklipper. Jobber i Drammen og omegn.',
    category: 'hagearbeid',
    location_fylke: 'viken',
    location_city: 'drammen',
    price: 175,
    job_type: 'tjeneste',
    pricing_type: 'hourly',
    hourly_rate: 175,
    status: 'active',
    created_at: '2026-01-06T11:00:00Z',
    images: [],
    poster: {
      id: 4,
      name: 'Erik Hansen',
      profile_image: null,
      is_verified: true
    }
  },
  {
    id: 104,
    title: 'Bærehjelp og småflytting',
    description: 'Sterk og villig til å hjelpe med bæring av møbler, esker og tunge ting. Kan også hjelpe med småflytting innad i Oslo.',
    category: 'flyttehjelp',
    location_fylke: 'oslo',
    location_city: 'oslo',
    price: 0,
    job_type: 'tjeneste',
    pricing_type: 'negotiable',
    hourly_rate: null,
    status: 'active',
    created_at: '2026-01-05T16:00:00Z',
    images: [],
    poster: {
      id: 1,
      name: 'Demo Bruker',
      profile_image: null,
      is_verified: true
    }
  }
];

// All jobs combined
export const ALL_MOCK_JOBS = [...MOCK_JOBS, ...MOCK_SERVICES];

// ============ MOCK CONVERSATIONS ============
export const MOCK_CONVERSATIONS = [
  {
    id: 1,
    other_user_id: 3,
    other_user_name: 'Kari Nordmann',
    other_user_image: null,
    job_id: 1,
    job_title: 'Trenger hjelp med plenklipping',
    job_image: null,
    job_price: 500,
    last_message: 'Supert! Da ses vi på lørdag kl. 10:00 👍',
    last_message_time: '2026-01-12T14:30:00Z',
    unread_count: 1
  },
  {
    id: 2,
    other_user_id: 5,
    other_user_name: 'Flyttebyrå Oslo',
    other_user_image: null,
    job_id: 2,
    job_title: 'Bærehjelp ved flytting',
    job_image: null,
    job_price: 200,
    last_message: 'Vi trenger 2 personer til mandag. Er du tilgjengelig?',
    last_message_time: '2026-01-11T09:15:00Z',
    unread_count: 0
  },
  {
    id: 3,
    other_user_id: 6,
    other_user_name: 'Lise Johansen',
    other_user_image: null,
    job_id: 5,
    job_title: 'Hundelufting i 2 uker',
    job_image: null,
    job_price: 2500,
    last_message: 'Takk for interessen! Kan du fortelle litt om din erfaring med hunder?',
    last_message_time: '2026-01-10T18:00:00Z',
    unread_count: 1
  }
];

// ============ MOCK MESSAGES ============
export const MOCK_MESSAGES = {
  1: [ // Conversation with Kari about plenklipping
    {
      id: 1,
      conversation_id: 1,
      sender_id: 1, // Demo user
      sender_name: 'Demo Bruker',
      sender_image: null,
      content: 'Hei! Jeg så annonsen din om plenklipping og er interessert. Jeg har erfaring med hagearbeid og kan gjøre jobben på lørdag hvis det passer?',
      image_url: null,
      created_at: '2026-01-11T10:00:00Z',
      read_at: '2026-01-11T10:05:00Z'
    },
    {
      id: 2,
      conversation_id: 1,
      sender_id: 3, // Kari
      sender_name: 'Kari Nordmann',
      sender_image: null,
      content: 'Hei! Så hyggelig å høre fra deg. Lørdag passer fint for meg. Når kan du komme?',
      image_url: null,
      created_at: '2026-01-11T11:30:00Z',
      read_at: '2026-01-11T11:35:00Z'
    },
    {
      id: 3,
      conversation_id: 1,
      sender_id: 1,
      sender_name: 'Demo Bruker',
      sender_image: null,
      content: 'Jeg kan komme rundt kl. 10:00. Gressklipperen er klar, sant?',
      image_url: null,
      created_at: '2026-01-11T12:00:00Z',
      read_at: '2026-01-11T12:10:00Z'
    },
    {
      id: 4,
      conversation_id: 1,
      sender_id: 3,
      sender_name: 'Kari Nordmann',
      sender_image: null,
      content: 'Ja, alt utstyr er klart! Adressen er Parkveien 15. Jeg er hjemme hele dagen, så bare ring på.',
      image_url: null,
      created_at: '2026-01-12T09:00:00Z',
      read_at: '2026-01-12T09:15:00Z'
    },
    {
      id: 5,
      conversation_id: 1,
      sender_id: 1,
      sender_name: 'Demo Bruker',
      sender_image: null,
      content: 'Perfekt! Da kommer jeg lørdag kl. 10:00. Gleder meg!',
      image_url: null,
      created_at: '2026-01-12T14:00:00Z',
      read_at: '2026-01-12T14:20:00Z'
    },
    {
      id: 6,
      conversation_id: 1,
      sender_id: 3,
      sender_name: 'Kari Nordmann',
      sender_image: null,
      content: 'Supert! Da ses vi på lørdag kl. 10:00 👍',
      image_url: null,
      created_at: '2026-01-12T14:30:00Z',
      read_at: null
    }
  ],
  2: [ // Conversation with Flyttebyrå
    {
      id: 7,
      conversation_id: 2,
      sender_id: 5,
      sender_name: 'Flyttebyrå Oslo',
      sender_image: null,
      content: 'Hei! Vi så at du er interessert i å hjelpe med bæring. Har du noen erfaring med tungt arbeid?',
      image_url: null,
      created_at: '2026-01-10T08:00:00Z',
      read_at: '2026-01-10T08:30:00Z'
    },
    {
      id: 8,
      conversation_id: 2,
      sender_id: 1,
      sender_name: 'Demo Bruker',
      sender_image: null,
      content: 'Hei! Ja, jeg har hjulpet familie og venner med flytting flere ganger. Jeg er sterk og liker fysisk arbeid.',
      image_url: null,
      created_at: '2026-01-10T09:00:00Z',
      read_at: '2026-01-10T09:10:00Z'
    },
    {
      id: 9,
      conversation_id: 2,
      sender_id: 5,
      sender_name: 'Flyttebyrå Oslo',
      sender_image: null,
      content: 'Flott! Vi betaler 200 kr/t og jobben tar vanligvis 4-5 timer.',
      image_url: null,
      created_at: '2026-01-10T14:00:00Z',
      read_at: '2026-01-10T14:30:00Z'
    },
    {
      id: 10,
      conversation_id: 2,
      sender_id: 5,
      sender_name: 'Flyttebyrå Oslo',
      sender_image: null,
      content: 'Vi trenger 2 personer til mandag. Er du tilgjengelig?',
      image_url: null,
      created_at: '2026-01-11T09:15:00Z',
      read_at: '2026-01-11T10:00:00Z'
    }
  ],
  3: [ // Conversation with Lise about dog walking
    {
      id: 11,
      conversation_id: 3,
      sender_id: 1,
      sender_name: 'Demo Bruker',
      sender_image: null,
      content: 'Hei! Jeg så annonsen din om hundelufting. Jeg elsker hunder og har tid til å hjelpe!',
      image_url: null,
      created_at: '2026-01-10T16:00:00Z',
      read_at: '2026-01-10T17:00:00Z'
    },
    {
      id: 12,
      conversation_id: 3,
      sender_id: 6,
      sender_name: 'Lise Johansen',
      sender_image: null,
      content: 'Takk for interessen! Kan du fortelle litt om din erfaring med hunder?',
      image_url: null,
      created_at: '2026-01-10T18:00:00Z',
      read_at: null
    }
  ]
};

// ============ MOCK REVIEWS ============
export const MOCK_REVIEWS = [
  {
    id: 1,
    rating: 5,
    comment: 'Veldig flink og punktlig! Gjorde en utmerket jobb med plenklippingen. Anbefales på det sterkeste!',
    created_at: '2025-12-15T14:00:00Z',
    reviewer: {
      id: 3,
      name: 'Kari Nordmann',
      profile_image: null
    },
    reviewed_id: 1 // Demo user
  },
  {
    id: 2,
    rating: 5,
    comment: 'Hardtarbeidende ungdom som gjør jobben ordentlig. Kom tidsnok og var hyggelig å ha med å gjøre.',
    created_at: '2025-11-20T10:00:00Z',
    reviewer: {
      id: 5,
      name: 'Flyttebyrå Oslo',
      profile_image: null
    },
    reviewed_id: 1
  },
  {
    id: 3,
    rating: 4,
    comment: 'God jobb med PC-oppsett. Litt treg i starten, men fikk alt til å fungere til slutt.',
    created_at: '2025-10-05T16:00:00Z',
    reviewer: {
      id: 6,
      name: 'Lise Johansen',
      profile_image: null
    },
    reviewed_id: 1
  },
  {
    id: 4,
    rating: 5,
    comment: 'Fantastisk! Hunden min elsket turene og alt gikk veldig bra.',
    created_at: '2025-12-20T12:00:00Z',
    reviewer: {
      id: 3,
      name: 'Kari Nordmann',
      profile_image: null
    },
    reviewed_id: 4 // Erik
  },
  {
    id: 5,
    rating: 5,
    comment: 'Profesjonell og pålitelig. Hagen har aldri sett bedre ut!',
    created_at: '2025-11-10T09:00:00Z',
    reviewer: {
      id: 6,
      name: 'Lise Johansen',
      profile_image: null
    },
    reviewed_id: 4
  },
  {
    id: 6,
    rating: 4,
    comment: 'Rask og effektiv hjelp med flyttingen. Anbefales!',
    created_at: '2025-09-25T15:00:00Z',
    reviewer: {
      id: 2,
      name: 'Hagesenter AS',
      profile_image: null
    },
    reviewed_id: 1
  },
  {
    id: 7,
    rating: 5,
    comment: 'Meget fornøyd! Vinduene skinner som aldri før.',
    created_at: '2025-08-15T11:00:00Z',
    reviewer: {
      id: 3,
      name: 'Kari Nordmann',
      profile_image: null
    },
    reviewed_id: 4
  },
  {
    id: 8,
    rating: 5,
    comment: 'Super jobb! Kom når de sa og var ferdig på estimert tid.',
    created_at: '2025-07-20T14:00:00Z',
    reviewer: {
      id: 5,
      name: 'Flyttebyrå Oslo',
      profile_image: null
    },
    reviewed_id: 4
  }
];

// Helper function to get reviews for a specific user
export const getReviewsForUser = (userId) => {
  return MOCK_REVIEWS.filter(review => review.reviewed_id === userId);
};

// Helper function to get user by ID
export const getUserById = (userId) => {
  return MOCK_USERS.find(user => user.id === userId);
};

// Helper function to get job by ID
export const getJobById = (jobId) => {
  return ALL_MOCK_JOBS.find(job => job.id === jobId);
};

// Helper function to get conversation by ID
export const getConversationById = (convId) => {
  return MOCK_CONVERSATIONS.find(conv => conv.id === convId);
};

// Helper function to get messages for a conversation
export const getMessagesForConversation = (convId) => {
  return MOCK_MESSAGES[convId] || [];
};

// Helper function to filter jobs
export const filterJobs = (filters = {}) => {
  let jobs = [...ALL_MOCK_JOBS];
  
  if (filters.fylke) {
    jobs = jobs.filter(job => job.location_fylke === filters.fylke);
  }
  if (filters.city) {
    jobs = jobs.filter(job => job.location_city === filters.city);
  }
  if (filters.category) {
    jobs = jobs.filter(job => job.category === filters.category);
  }
  if (filters.job_type) {
    jobs = jobs.filter(job => job.job_type === filters.job_type);
  }
  if (filters.q) {
    const query = filters.q.toLowerCase();
    jobs = jobs.filter(job => 
      job.title.toLowerCase().includes(query) || 
      job.description.toLowerCase().includes(query)
    );
  }
  if (filters.minPrice) {
    jobs = jobs.filter(job => job.price >= parseFloat(filters.minPrice));
  }
  if (filters.maxPrice) {
    jobs = jobs.filter(job => job.price <= parseFloat(filters.maxPrice));
  }
  
  return jobs;
};
